import script from "./TempN.vue?vue&type=script&lang=ts&setup=true"
export * from "./TempN.vue?vue&type=script&lang=ts&setup=true"

import "./TempN.vue?vue&type=style&index=0&id=b6e38796&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6e38796"]])

export default __exports__